/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { sqrtDependencies } from './dependenciesSqrt.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { varianceDependencies } from './dependenciesVariance.generated';
import { createStd } from '../../factoriesAny.js';
export var stdDependencies = {
  sqrtDependencies: sqrtDependencies,
  typedDependencies: typedDependencies,
  varianceDependencies: varianceDependencies,
  createStd: createStd
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesStd.generated.js
// module id = 1524
// module chunks = 0